import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Shield, Gift, Star } from "lucide-react";

const T = {
  en: { shield: "You won a new shield!", shieldSub: "You mastered a whole chapter. Amazing work!",
        avatar: "You unlocked a new avatar!", avatarSub: "Go to your collection and pick your new friend.",
        both: "Shield + new avatar!", pick: "Choose my avatar", ok: "Awesome!" },
  fr: { shield: "Tu as gagné un nouveau bouclier !", shieldSub: "Tu as maîtrisé un chapitre entier. Bravo !",
        avatar: "Tu as débloqué un nouvel avatar !", avatarSub: "Va dans ta collection et choisis ton nouvel ami.",
        both: "Bouclier + nouvel avatar !", pick: "Choisir mon avatar", ok: "Génial !" },
};

export default function RewardCelebration({ shield, avatar, lang = "en", onCollection }) {
  const [open, setOpen] = useState(shield || avatar);
  const t = T[lang] || T.en;
  const Icon = avatar ? Gift : Shield;
  const title = shield && avatar ? t.both : avatar ? t.avatar : t.shield;
  const sub = avatar ? t.avatarSub : t.shieldSub;
  return (
    <AnimatePresence>
      {open && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[60] bg-[#1E5EFF]/90 backdrop-blur-sm flex items-center justify-center p-5 overflow-hidden" data-testid="reward-celebration">
          {[...Array(14)].map((_, k) => (
            <motion.div key={k} className="absolute" style={{ left: `${(k * 37) % 100}%`, top: "-5%" }}
              initial={{ y: 0, rotate: 0, opacity: 0 }} animate={{ y: "110vh", rotate: 360, opacity: [0, 1, 1, 0] }}
              transition={{ duration: 2.6 + (k % 4) * 0.4, delay: k * 0.12, repeat: Infinity }}>
              <Star size={18 + (k % 3) * 8} fill={["#FFC83D", "#FF6B4A", "#22C08A", "#A66CFF"][k % 4]} className="text-transparent" />
            </motion.div>
          ))}
          <motion.div initial={{ scale: 0.6, rotate: -6 }} animate={{ scale: 1, rotate: 0 }} transition={{ type: "spring", stiffness: 260, damping: 14 }}
            className="relative bg-white rounded-[36px] p-8 max-w-sm w-full text-center font-kids shadow-[0_30px_80px_rgba(0,0,0,0.35)]">
            <motion.div animate={{ rotate: [0, -8, 8, 0], scale: [1, 1.1, 1] }} transition={{ duration: 1.4, repeat: Infinity }}
              className={`w-28 h-28 mx-auto rounded-full flex items-center justify-center ${avatar ? "bg-[#FF6B4A]" : "bg-[#3D8BFF]"}`}>
              <Icon color="#fff" size={56} />
            </motion.div>
            <h2 className="text-3xl font-black mt-5 text-slate-900" data-testid="reward-celebration-title">{title}</h2>
            <p className="font-parent text-slate-600 mt-2">{sub}</p>
            {avatar && onCollection && (
              <button onClick={() => { setOpen(false); onCollection(); }} data-testid="reward-celebration-collection"
                className="mt-6 w-full rounded-full bg-[#FFC83D] text-slate-900 font-bold py-3 hover:bg-[#FFB800] transition-colors">{t.pick}</button>
            )}
            <button onClick={() => setOpen(false)} data-testid="reward-celebration-close"
              className={`${avatar && onCollection ? "mt-3 bg-white border-2 border-slate-900" : "mt-6 bg-[#1E5EFF] text-white"} w-full rounded-full font-bold py-3 transition-colors`}>{t.ok}</button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
